// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__pA2uI","consentsList":"PatientConsents_consentsList__22CsX","consentsListEmpty":"PatientConsents_consentsListEmpty__3LgRz"};